import React from 'react'
import { connect } from 'react-redux'
import { ContentHeader, StaticBox, FlowTable } from 'components/basic'
import FlowView from 'components/core/FlowView'
import { notify, date } from 'helpers'
import http from 'API/http'
import Select from 'react-select'

class OrderOverview extends FlowView {
  constructor (props) {
    super(props, 'Orders')
    this.state = {
      orders: [],
      stateFilter: '',
      loading: true
    }
  }
  componentDidMount () {
    this.getData()
  }
  async getData () {
    this.setState({loading: true})
    var [err, res] = await http.get('2.4/orders', (this.state.stateFilter && {state: this.state.stateFilter}))
    if (err) return notify.alert('', res.cause, 'error')
    this.setState({orders: res.data, loading: false})
  }


  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Orders' subtitle='Overview' icon='fa-first-order' />
        <hr />
        <div className='row'>
          <StaticBox cols={12} icon='filter' title='Filter'>
            <div className='row'>
              <div className='col-md-2 col-sm-4'>
                <span className='access-filter-name'>Filter by State</span>
              </div>
              <div className='col-md-10'>
                <Select
                  searchable
                  labelKey='value'
                  valueKey='value'
                  clearable
                  value={this.state.stateFilter}
                  options={[{value: 'DONE_SUCCESS'}, {value: 'DONE_FAILED'}, {value: 'IN_PROGRESS'}, {value: 'RECEIVED'}]}
                  onChange={(state) => this.setState({stateFilter: (state ? state.value : '')}, this.getData)}
                />
              </div>
            </div>
          </StaticBox>
          <StaticBox cols={12} icon='first-order' title='Orders'>
            <FlowTable loading={this.state.loading} paginatable={20} data={
                this.state.orders.map(order => [
                  {onClick: e => (window.location.href = '/#/access/' + order.accessId)},
                  <a href={'/#/access/' + order.accessId} className='table-link'><i className='fa fa-folder-open-o' /></a>,
                  order.accessId,
                  <span className={'label orders-label label-' + (order.state === 'DONE_FAILED' ? 'danger' : (order.state === 'IN_PROGRESS' ? 'warning' : 'success'))}><b>{order.state}</b></span>,
                  order.operation,
                  order.service,
                  date.format(order.requestedDateTime)
                ])}>
              <tr>
                <th className='buttons' />
                <th>Access ID</th>
                <th style={{'width': '120px'}}>State</th>
                <th>Operation</th>
                <th>Service</th>
                <th>Time</th>
              </tr>
            </FlowTable>
          </StaticBox>
        </div>
      </div>
    )
  }
}
//eslint-disable-next-line
OrderOverview = connect(state => state.siteReducer)(OrderOverview)
export default OrderOverview



// WEBPACK FOOTER //
// ./src/projects/access-gui/views/orders/overview.js